<!-- Start Navbar -->
<nav id="topnav" class="defaultscroll is-sticky" [ngClass]="scrolled ? 'nav-sticky' : ''">
  <div class="container">
    <!-- Logo container-->
    <ng-container *ngIf="navLight; else elseTemplate">
      <a class="logo ps-0" [routerLink]="'/'">
        <img [src]="'assets/images/logo-icon-28.png'" class="inline-block sm:hidden" alt="">
        <div class="sm:block hidden">
                    <span class="inline-block dark:hidden">
                        <img [src]="'assets/images/logo-dark.png'" class="l-dark h-7" alt="">
                        <img [src]="'assets/images/logo-light.png'" class="l-light h-7" alt="">
                    </span>
          <img [src]="'assets/images/logo-white.png'" height="24" class="hidden dark:inline-block" alt="">
        </div>
      </a>
    </ng-container>
    <ng-template #elseTemplate>
      <a class="logo ps-0" [routerLink]="'/'">
        <img [src]="'assets/images/logo-icon-28.png'" class="inline-block sm:hidden" alt="">
        <div class="sm:block hidden">
          <img [src]="'assets/images/logo-dark.png'" class="inline-block dark:hidden h-7" alt="">
          <img [src]="'assets/images/logo-white.png'" class="hidden dark:inline-block h-7" alt="">
        </div>
      </a>
    </ng-template>

    <!-- End Logo container-->

    <div class="menu-extras">
      <div class="menu-item">
        <!-- Mobile menu toggle-->
        <a class="navbar-toggle" [ngClass]="open ? 'open' : ''" id="isToggle" (click)="toggleMenu($event)">
          <div class="lines">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </a>
        <!-- End mobile menu toggle-->
      </div>
    </div>

    <!--Login button Start-->
    <ul class="buy-button list-none mb-0">
      <!-- Language Switcher -->
      <li class="inline-block mb-0 me-1">
        <app-language-switcher/>
      </li>

      <li class="dropdown inline-block relative ps-1" (clickOutside)="onClickedOutsideUser($event)" *ngIf="isAuthenticated && userData">
        <button (click)="setUser = !setUser"
                class="dropdown-toggle btn btn-icon rounded-full bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white inline-flex"
                type="button">
          <img [src]="'assets/images/client/01.jpg'" class="rounded-full" alt="">
        </button>
        <!-- Dropdown menu -->
        <div *ngIf="setUser"
             class="dropdown-menu absolute end-0 m-0 mt-4 z-10 min-w-48 rounded-md overflow-hidden bg-white dark:bg-slate-900 shadow dark:shadow-gray-800">
          <div class="relative">
            <div class="py-8 bg-gradient-to-tr from-violet-600 to-red-600"></div>
            <div class="absolute px-4 -bottom-7 start-0">
              <div class="flex items-end">
                <img ngSrc="assets/images/client/01.jpg" class="rounded-full w-10 h-w-10 shadow dark:shadow-gray-700" alt="" height="40" width="40">
                <span class="font-semibold text-[15px] ms-1">{{ userData.name || userData.preferredUsername }}</span>
              </div>
            </div>
          </div>

          <ul class="mt-10 py-2 text-start">
            <li>
              <a [routerLink]="'/user/conquer-accounts'"
                 class="block text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><i
                class="uil uil-user-plus text-[16px] align-middle me-1"></i> {{ 'NAVBAR.USER.CONQUER_ACCOUNTS' | translate }}</a>
            </li>
            <li>
              <a [routerLink]="'/user/conquer-vip'"
                 class="block text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><i
                class="uil uil-star text-[16px] align-middle me-1"></i> {{ 'NAVBAR.USER.VIP' | translate }}</a>
            </li>
            <li class="border-t border-gray-100 dark:border-gray-800 my-2"></li>
            <li>
              <a [routerLink]="'/settings/profile'"
                 class="block text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><i
                class="uil uil-user text-[16px] align-middle me-1"></i> {{ 'NAVBAR.USER.PROFILE' | translate }}</a>
            </li>
            <li>
              <a [routerLink]="'/settings/general'"
                 class="block text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><i
                class="uil uil-setting text-[16px] align-middle me-1"></i> {{ 'NAVBAR.USER.SETTINGS' | translate }}</a>
            </li>
            <li class="border-t border-gray-100 dark:border-gray-800 my-2"></li>
            <li *ngIf="isPigletAllowed">
              <a [routerLink]="'/piglet/dashboard'"
                 class="block text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><i
                class="uil uil-bag text-[16px] align-middle me-1"></i> {{ 'NAVBAR.USER.PIGLET' | translate }}</a>
            </li>
            <li *ngIf="isPigletAllowed" class="border-t border-gray-100 dark:border-gray-800 my-2"></li>
            <li>
              <a [routerLink]="" (click)="logout()" class="block text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><i
                class="uil uil-sign-out-alt text-[16px] align-middle me-1"></i> {{ 'NAVBAR.USER.LOGOUT' | translate }}</a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <!--Login button End-->

    <div id="navigation" [ngClass]="open ? 'block' : ''">
      <!-- Navigation Menu-->
      <ul class="navigation-menu justify-end" [ngClass]="navLight ? 'nav-light' : ''">
        <li class="ms-0" [class.active]="menu === '/home'"><a [routerLink]="'/home'" class="sub-menu-item">{{ 'NAVBAR.HOME' | translate }}</a></li>
<!--        <li class="ms-0" [class.active]="['/user'].includes(menu)" *ngIf="isAuthenticated"><a [routerLink]="'/user'" class="sub-menu-item">{{ 'NAVBAR.USER_CP' | translate }}</a></li>-->
        <li class="ms-0" [class.active]="menu === '/register'" *ngIf="!isAuthenticated"><a [routerLink]="'/register'" class="sub-menu-item">{{ 'NAVBAR.REGISTER' | translate }}</a></li>
        <li class="has-submenu parent-parent-menu-item ms-0" [class.active]="['/download','/download/client','/download/patches'].includes(menu)">
          <a [routerLink]="" (click)="openMenu($event, '/download')">{{ 'NAVBAR.DOWNLOAD' | translate }}</a><span class="menu-arrow"></span>
          <ul class="submenu" [class.active]="['/download'].includes(subMenu) ? 'open' : ''">
            <li class="ms-0" [class.active]="['/download','/download/client'].includes(menu)"><a [routerLink]="'/download/client'" class="sub-menu-item">{{ 'NAVBAR.DOWNLOAD_CLIENT' | translate }}</a></li>
            <li class="ms-0" [class.active]="menu === '/download/patches'"><a [routerLink]="'/download/patches'" class="sub-menu-item">{{ 'NAVBAR.DOWNLOAD_PATCHES' | translate }}</a></li>
          </ul>
        </li>
        <li class="ms-0" [class.active]="menu === '/guides'"><a [routerLink]="'/guides'" class="sub-menu-item">{{ 'NAVBAR.GUIDES' | translate }}</a></li>
<!--        <li class="ms-0" [class.active]="menu === '/contact'"><a [routerLink]="'/contact'" class="sub-menu-item">{{ 'NAVBAR.CONTACT' | translate }}</a></li>-->
        <li class="ms-0" *ngIf="!isAuthenticated"><a [routerLink]="'/login'" class="sub-menu-item">{{ 'NAVBAR.SIGNIN' | translate }}</a></li>
      </ul><!--end navigation menu-->
    </div><!--end navigation-->
  </div><!--end container-->
</nav><!--end header-->
<!-- End Navbar -->
